
import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";

interface FeedbackStatsProps {
  totalCourses: number;
  totalFeedback: number;
  avgRating: number;
  recommendRate: number;
}

const FeedbackStats: React.FC<FeedbackStatsProps> = ({ 
  totalCourses, 
  totalFeedback, 
  avgRating, 
  recommendRate 
}) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      <Card className="border-accent-light overflow-hidden">
        <CardHeader className="pb-2 bg-primary/5">
          <CardTitle className="text-sm font-medium text-primary font-section">
            Total Courses with Feedback
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-primary font-title">{totalCourses}</div>
        </CardContent>
      </Card>
      
      <Card className="border-accent-light overflow-hidden">
        <CardHeader className="pb-2 bg-primary/5">
          <CardTitle className="text-sm font-medium text-primary font-section">
            Total Feedback Submissions
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-primary font-title">{totalFeedback}</div>
        </CardContent>
      </Card>
      
      <Card className="border-accent-light overflow-hidden">
        <CardHeader className="pb-2 bg-primary/5">
          <CardTitle className="text-sm font-medium text-primary font-section">
            Average Overall Rating
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-primary font-title">{avgRating.toFixed(1)}/4</div>
          <div className="flex mt-1">
            {[...Array(4)].map((_, i) => (
              <span 
                key={i} 
                className={`text-lg ${i < Math.round(avgRating) ? 'text-amber-400' : 'text-gray-300'}`}
              >
                ★
              </span>
            ))}
          </div>
        </CardContent>
      </Card>
      
      <Card className="border-accent-light overflow-hidden">
        <CardHeader className="pb-2 bg-primary/5">
          <CardTitle className="text-sm font-medium text-primary font-section">
            Would Recommend Rate
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-primary font-title">{(recommendRate * 100).toFixed(0)}%</div>
          <Progress 
            value={recommendRate * 100} 
            className="h-2.5 mt-2" 
            indicatorClassName="bg-accent"
          />
        </CardContent>
      </Card>
    </div>
  );
};

export default FeedbackStats;
